module.exports = __webpack_public_path__ + "images/upload-image7ad3edd3e23238f44a3d95d419019e43.webp";